import _ from 'lodash';

export function value<
  ReturnType,
>(
  pathParts: readonly string[],
  settings: object,
): ReturnType | undefined;

export function value<
  ReturnType,
>(
  pathParts: readonly string[],
  settings: object,
  scope: readonly string[]
): ReturnType | undefined;

export function value<
  ReturnType,
>(
  pathParts: readonly string[],
  settings: object,
  scope: readonly string[],
  defaultValue: ReturnType,
): ReturnType;

export function value<
  ReturnType = undefined,
>(
  pathParts: readonly string[],
  settings: object,
  scope: readonly string[] = [],
  defaultValue: ReturnType | undefined = undefined,
): ReturnType | undefined {
  const name = scope.concat(pathParts).join('.');
  const result = _.get(settings, name);
  if (_.isNil(result)) {
    return scope.length === 0 ? defaultValue : value(
      pathParts,
      settings,
      _.initial(scope),
      defaultValue,
    );
  }
  return result;
}
